import React, { Component } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'

const TitleContainer = styled.div`
  & .price {
    font-weight: bold;
  }
`

class CarsTitle extends Component {
  render () {
    const {
      box: {
        annotation,
        price,
        title
      }
    } = this.props

    return (
      <TitleContainer>
        <div className='title'>
          { title }
        </div>
        <div className='annotation'>
          { annotation }
        </div>
        <div className='price'>
          { price } Kč
        </div>
      </TitleContainer>
    )
  }
}

CarsTitle.propTypes = {
  box: PropTypes.object.isRequired
}

export default CarsTitle
